import type { FaixaDaGlosa, PainelDoIad } from '../../types/iad'

import { data, dataHora, dataSimples } from '../../lib/datas'

/**
 * Uma data SEM hora do servidor — `ocorrido_em`, `entregue_em` — escrita como se lê.
 *
 * **Delega para `dataSimples`, que NÃO converte fuso**, e a razão está lá: `new Date('2026-09-02')`
 * formatado no fuso de Niterói volta como 01/09/2026, um dia antes. Isto já esteve errado aqui.
 *
 * @param iso a data em `AAAA-MM-DD`, ou nulo
 * @returns a data em pt-BR, ou string vazia
 */
export function dataPorExtenso(iso: string | null): string {
  return dataSimples(iso, '')
}

/**
 * A data de um INSTANTE do servidor — com hora e sufixo Z.
 *
 * Aqui a conversão de fuso é necessária e correta: o instante existe em UTC e precisa virar a data
 * de Niterói. É o oposto de {@link dataPorExtenso}, e confundir os dois erra um dia.
 *
 * @param iso o instante em ISO, ou nulo
 * @returns a data em pt-BR, ou string vazia
 */
export function dataDoInstante(iso: string | null): string {
  return data(iso, '')
}

/**
 * Um instante do servidor, com hora.
 *
 * @param iso o instante em ISO, ou nulo
 * @returns data e hora em pt-BR, ou string vazia
 */
export function instantePorExtenso(iso: string | null): string {
  return dataHora(iso, '')
}

/**
 * A próxima faixa da tabela, quando existe.
 *
 * A tela precisa dizer "faltam 8 pontos para o desconto subir para 7%", e o 7% sai daqui. É a
 * informação que o fiscal usa para decidir se investiga mais uma candidata hoje ou no mês que vem —
 * a diferença entre faltar 1 ponto e faltar 11 muda a prioridade da tarefa dele.
 *
 * @param painel o painel do mês
 * @returns a faixa seguinte, ou nulo quando já está na última
 */
export function proximaFaixa(painel: PainelDoIad): FaixaDaGlosa | null {
  if (painel.pontosParaAProximaFaixa <= 0) {
    return null
  }
  return painel.tabela.find((f) => f.redutorPercentual > painel.faixa.redutorPercentual) ?? null
}

/** As ocorrências que somam pontos, na ordem em que a tela as mostra. */
export function ocorrenciasVivas(painel: PainelDoIad) {
  return painel.ocorrencias.filter((o) => o.revogadaEm == null)
}

/** As que foram retiradas da soma e continuam visíveis para quem auditar. */
export function ocorrenciasRevogadas(painel: PainelDoIad) {
  return painel.ocorrencias.filter((o) => o.revogadaEm != null)
}
